@if (isLoading){
  <section class="loading">
    <p-skeleton width="14rem" height="2.5rem" />
    <p-skeleton height="8rem" />
  </section>
} @else {
  <form [formGroup]="formGroup">

    @if ((mode === 'create' || mode === 'edit') && actionsForm.controls.length > 0) {
      <div class="create">
        <app-button-icon label="common.actions.add-alarm-rule-action"
                         [isTranslated]="true"
                         iconName="add"
                         (click)="createActionOnClick()" />
      </div>
    }

    @if (actionsForm.controls.length) {
      <div class="list"
           formArrayName="actions">
        @for (action of actionsForm.controls; track $index; let i = $index) {
          <div class="card"
               [formGroupName]="i">
            <div class="content">
              <span class="title">
                <span class="material-symbols-rounded upload-icon">
                  {{ getIcon(i) }}
                </span>
                {{ getName(i) | translateSafe }}
              </span>

              @if (getActionType(i); as actionType) {
                <ng-container
                  *ngComponentOutlet="
                    this.getDefinition(actionType).getEditorComponent();
                    inputs: {
                      formGroup: action,
                      mode: mode ==  'create' ? 'edit' : mode,
                      action: getAction(i)
                    }
                  ">
                </ng-container>
              }
            </div>

            @if (mode === 'create' || mode === 'edit') {
              <app-button-icon
                class="red"
                iconName="delete"
                (click)="removeAction($index)" />
            }
          </div>
        }
      </div>
    } @else {
      <div class="empty-triggers">
        <span class="material-symbols-rounded red">
          error
        </span>

        @if (mode == 'view') {
          <span>
            {{ 'common.alarm-rule.action.view.empty-message' | translateSafe }}
          </span>
        } @else {
          <span>
            {{ 'common.alarm-rule.action.edit.empty-message' | translateSafe }}
          </span>
          <app-button-icon label="common.actions.add-alarm-rule-action"
                           [isTranslated]="true"
                           iconName="add"
                           (click)="createActionOnClick()" />
        }
      </div>
    }
  </form>

  <!--<p-accordion>
    <p-accordion-panel value="0">
      <p-accordion-header>
                  <span class="p-accordion-header-text">
                    Nachricht Variablen
                  </span>
      </p-accordion-header>

      <p-accordion-content>
        <table class="variable-table">
          <thead>
          <tr>
            <th>Variable</th>
            <th>Beschreibung</th>
          </tr>
          </thead>

          <tbody>
          <tr>
            <td colspan="2"
                class="center">
              Regel bezogen
            </td>
          </tr>
          <tr>
            <td>
              <code>$alarmRule.id</code>
            </td>
            <td>ID der Alarmregel</td>
          </tr>
          <tr>
            <td>
              <code>$alarmRule.name</code>
            </td>
            <td>Name der Alarmregel</td>
          </tr>
          <tr>
            <td>
              <code>$alarmRule.severity</code>
            </td>
            <td>Schweregrad des Alarms</td>
          </tr>
          <tr>
            <td>
              <code>$alarmRule.alarm_type</code>
            </td>
            <td>Typ des Alarms</td>
          </tr>
          <tr>
            <td>
              <code>$alarmRule.cooldown_sec</code>
            </td>
            <td>Cooldown-Zeit in Sekunden</td>
          </tr>
          <tr>
            <td>
              <code>$alarmRule.is_active</code>
            </td>
            <td>Gibt an, ob die Regel aktiv ist</td>
          </tr>
          <tr>
            <td>
              <code>$alarmRule.created_at</code>
            </td>
            <td>Erstellungsdatum der Alarmregel</td>
          </tr>
          <tr>
            <td>
              <code>$alarmRule.updated_at</code>
            </td>
            <td>Aktualisierungsdatum der Alarmregel</td>
          </tr>
          <tr>
            <td colspan="2"
                class="center">
              Geräte bezogen
            </td>
          </tr>
          <tr>
            <td>
              <code>$device.id</code>
            </td>
            <td>ID des Geräts</td>
          </tr>
          <tr>
            <td>
              <code>$device.serial_number</code>
            </td>
            <td>Serial Nummer des Geräts</td>
          </tr>
          <tr>
            <td>
              <code>$device.device_eui</code>
            </td>
            <td>Device EUI</td>
          </tr>
          <tr>
            <td>
              <code>$device.description</code>
            </td>
            <td>Beschreibung des Geräts</td>
          </tr>
          <tr>
            <td>
              <code>$device.status</code>
            </td>
            <td>Status des Geräts, z. B. online oder offline</td>
          </tr>
          <tr>
            <td>
              <code>$device.device_profile_id</code>
            </td>
            <td>ID des zugehörigen Device Profiles</td>
          </tr>
          <tr>
            <td>
              <code>$device.last_measurement_received_time</code>
            </td>
            <td>Zeitpunkt der letzten empfangenen Messung</td>
          </tr>
          <tr>
            <td>
              <code>$device.created_at</code>
            </td>
            <td>Erstellungsdatum des Geräts</td>
          </tr>
          <tr>
            <td>
              <code>$device.updated_at</code>
            </td>
            <td>Aktualisierungsdatum des Geräts</td>
          </tr>
          <tr>
            <td colspan="2"
                class="center">
              Geräte Profil bezogen
            </td>
          </tr>
          <tr>
            <td>
              <code>$deviceProfile.id</code>
            </td>
            <td>ID des Device Profiles</td>
          </tr>
          <tr>
            <td>
              <code>$deviceProfile.name</code>
            </td>
            <td>Name des Device Profiles</td>
          </tr>
          <tr>
            <td>
              <code>$deviceProfile.description</code>
            </td>
            <td>Beschreibung des Device Profiles</td>
          </tr>
          <tr>
            <td>
              <code>$deviceProfile.created_at</code>
            </td>
            <td>Erstellungsdatum des Device Profiles</td>
          </tr>
          <tr>
            <td>
              <code>$deviceProfile.updated_at</code>
            </td>
            <td>Aktualisierungsdatum des Device Profiles</td>
          </tr>
          </tbody>
        </table>
      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>-->

  <app-dialog-base [class.open]="addDialogOpen"
                   iconLeft="add_diamond"
                   [buttonAction]="() => addDialogOpen = false"
                   (outSideClick)="addDialogOpen = false"
                   title="dialogs.alarm-rule.add-action">

    <app-input-item-selection [formData]="TypeSelect"
                              (selectedOption)="onTypeSelect($event)" />

  </app-dialog-base>
}
